module.exports = __webpack_public_path__ + "img/png_3d.75702843.png";